const terms = [
  {
    id: 1,
    title: "التعريفات",
    text: [
      "المستخدم: كل من يستخدم التطبيق بغرض التطوع أو البحث عن فرص تطوعية.",
      "الجهة المستضيفة: المؤسسات أو الأفراد الذين يقدمون فرص تطوعية عبر التطبيق.",
    ],
  },
  {
    id: 2,
    title: "التسجيل والحساب",
    text: [
      "يجب على المستخدم تقديم معلومات صحيحة ودقيقة عند التسجيل.",
      "المستخدم مسؤول عن الحفاظ على سرية بيانات الدخول إلى حسابه.",
    ],
  },
  {
    id: 3,
    title: "استخدام التطبيق",
    text: [
      "يحق للمستخدم استخدام التطبيق للأغراض التطوعية فقط.",
      "يُمنع استخدام التطبيق لأي نشاط غير قانوني أو مخالف للأخلاق.",
    ],
  },
  {
    id: 4,
    title: "المحتوى والفرص التطوعية",
    text: [
      "يتم تقديم الفرص التطوعية من قبل الجهات المستضيفة، ويحق لهم تعديل أو إلغاء الفرص في أي وقت.",
      "التطبيق لا يتحمل مسؤولية دقة أو جودة الفرص المنشورة.",
    ],
  },
  {
    id: 5,
    title: "حقوق الملكية الفكرية",
    text: [
      "جميع محتويات التطبيق (النصوص، الصور، الشعارات، التصاميم) محمية بحقوق الملكية ولا يجوز استخدامها بدون إذن.",
    ],
  },
  {
    id: 6,
    title: "الخصوصية",
    text: [
      "نلتزم بحماية بياناتك الشخصية وفقًا لسياسة الخصوصية المعلنة.",
    ],
  },
  {
    id: 7,
    title: "إخلاء المسؤولية",
    text: [
      "التطبيق يُقدم 'كما هو' دون ضمانات صريحة أو ضمنية.",
      "لا نتحمل أي أضرار ناتجة عن استخدام التطبيق أو الاعتماد على محتواه.",
    ],
  },
  {
    id: 8,
    title: "التعديلات",
    text: [
      "نحتفظ بحق تعديل هذه الشروط في أي وقت، وسيتم إعلام المستخدمين بأي تغييرات جوهرية.",
    ],
  },
  {
    id: 9,
    title: "القانون المعمول به",
    text: [
      "تخضع هذه الشروط للأحكام والقوانين المعمول بها في الدولة.",
    ],
  },
];

export default terms;